import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Table, TableHead, TableCell, TableBody, TableRow, Typography, Tooltip } from '@mui/material';
import { Grid, Link, Paper } from '@mui/material';
import { TablePagination } from '@mui/material';


import PageTitle from '../ui/PageTitle';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';

import { green, red } from '@mui/material/colors';


const abEnvironment = new AbEnvironment();

const TemplateAppSearchQuery = graphql`
query TemplateAppSearchQuery($appName: String!, $accountName: String!, $first: Int, $offset: Int) {
  templateappsearch(appname: $appName, accountname: $accountName, first: $first, offset: $offset) {
    totalCount
    nodes {
      appId
      accountId,
    	accountName,
      accountType,
    	appStatus,
    	oemAppId,
    	appName,
    	appSku,
    	appLogo,
    	description,
    	marqetaMid,
    	marqetaMname,
    	maxCharge
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  radio: {
    marginTop: 16
  },
  formControl: {
    marginTop: '24',
  },
  nselect: {
    minWidth: 150
  }
});

class TemplateAppSearch extends Component {
  state = {
    accountName: '',
    appName: '',
    page: 0,
    rowsPerPage: 10
  };



  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }


  goTo(route) {
    
    this.props.history.push(`/${route}`);
  }

  getAccountName = (customerName) => {

    var limit = 30;  //seems to be a good general fit
    if (customerName.length > limit) {
      // Find the space before that.
      let theSubstr = customerName.substring(0, limit);
      let lastSpaceIdx = theSubstr.lastIndexOf(' ');
      return customerName.substring(0, lastSpaceIdx) + '...';
    } else {
      return customerName;
    }
  }

  render() {
    const { isAuthenticated, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const statusOk = green[300];
    const statusCancelled = red[300];

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedAppBind()) {


      return (
        <main>

          <PageTitle title="Template App Search" subtitle="Search for those apps that are vendor templates or standalone for a reseller"/>
          <Grid container spacing={1} direction="row" justifyContent="flex-start" style={{marginTop: '-24px'}}>
            

            <Grid item>
              <SearchField
                id="app-name-search"
                label="Search by app name"
                value={this.state.appName}
                onChange={this.handleChange('appName')}
              />

            </Grid>
            <Grid item>
              <SearchField
                id="account-name-search"
                label="Search by account name"
                value={this.state.accountName}
                onChange={this.handleChange('accountName')}
              />
            </Grid>

          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={TemplateAppSearchQuery}
            variables={{appName: this.state.appName,
                        accountName: this.state.accountName,
                        accountNumber: this.state.customerNum,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.templateappsearch.totalCount;

                let apps = props.templateappsearch.nodes;


                return ( 
                  <div className={classes.paper}>
                    <Paper >
                      <Table>
                          <TableHead style={AppBindStyles.tableHead}>
                              <TableRow style={AppBindStyles.tableHeadRow}>
                                  <TableCell>App name</TableCell>
                                  <TableCell>Subscription level</TableCell>
                                  <TableCell>Account name</TableCell>
                                  <TableCell>Account type</TableCell>
                                  <TableCell>Status</TableCell>
                             </TableRow>
                          </TableHead>
                          <TableBody>
                              {apps.map(app => {

                                  let accountType = 'Vendor';
                                  if (app.accountType === 2) {
                                    accountType = 'Distributor';
                                  } else if (app.accountType === 3) {
                                    accountType = 'Reseller';
                                  } else if (app.accountType === 4) {
                                    accountType = 'Customer';
                                  }
                                  let aUrl = 'templateappedit?appId=' + app.appId;
                                  return (
                                      <TableRow key={app.appId}>
                                          <TableCell>
                                            <Link component="button" 
                                                  variant="body2"
                                                  className={classes.custlink}
                                                  onClick={this.goTo.bind(this, aUrl)}>
                                              {app.appName}
                                            </Link>
                                          </TableCell>
                                          <TableCell align="left">{app.appSku}</TableCell>
                                          <TableCell align="left">{app.accountName}</TableCell>
                                          <TableCell align="left">{accountType}</TableCell>
                                          <TableCell>
                                          { app.appStatus === 0 &&  
                                            <CheckCircle htmlColor={statusOk}/>
                                          }

                                          { app.appStatus === 1 &&
                                              <Tooltip title="This customer is cancelled">
                                                  <Cancel htmlColor={statusCancelled}/>
                                              </Tooltip>
                                          }

                                          </TableCell>
                                      </TableRow>
                                  );
                              })}
                          </TableBody>
                      </Table>
                    </Paper>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

TemplateAppSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(TemplateAppSearch);
